import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  uuid: null,
};

const membershipsDialogSlice = createSlice({
  name: "membershipsDialogSlice",
  initialState,
  reducers: {
    setMembershipDialogUuid: (state, { payload }) => {
      state.uuid = payload;
    },
    clearMembershipDialogUuid: (state) => {
      state.uuid = null;
    },
  },
});

export const { setMembershipDialogUuid, clearMembershipDialogUuid } =
  membershipsDialogSlice.actions;
export const membershipsDialogReducer = membershipsDialogSlice.reducer;
